import { render, staticRenderFns } from "./search-links.vue?vue&type=template&id=459c5d24&scoped=true&"
import script from "./search-links.vue?vue&type=script&lang=js&"
export * from "./search-links.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459c5d24",
  null
  
)

export default component.exports